export default __webpack_public_path__ + "static/media/Sinstrike.369e6d6b.jpg";